import { UserAuthDTO } from '../../../src_server/entity/dto/UserAuthDTO';


import { GeneratedBizBase } from '../GeneratedBizBase';


import { Response } from '../../../src_server/response/Response';export class AuthService extends GeneratedBizBase{
  async forceLogin(user_id: string,type: string,building: string): Promise<Response<UserAuthDTO>> {
    return super.restCall<Response<UserAuthDTO>>('post', '/v1/AuthService/forceLogin', arguments);
  }
  async isMember(user_id: string): Promise<Response<boolean>> {
    return super.restCall<Response<boolean>>('get', '/v1/AuthService/isMember', arguments);
  }
  async loginByMail(mail: string,password: string,linkToken: string): Promise<Response<UserAuthDTO>> {
    return super.restCall<Response<UserAuthDTO>>('post', '/v1/AuthService/loginByMail', arguments);
  }
  async resetInitPassword(user_id: string,building: string): Promise<Response<string>> {
    return super.restCall<Response<string>>('post', '/v1/AuthService/resetInitPassword', arguments);
  }
}
